import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";

import { SuggestedActions } from "./SuggestedActions";

import { FORM_AUTHORING_COACH_START_QUERY } from "../constants";

type FormAuthoringCoachSuggestedActionsProps = {
	onSelect: (query: string) => void;
};

/**
 * Contextual chat action offered while an employee fills out a review form. It sits above the chat
 * input rather than in the empty-state card grid: the cards are for work the user can start from
 * anywhere, and this one only means anything on the review they're authoring.
 */
export const FormAuthoringCoachSuggestedActions: React.FC<FormAuthoringCoachSuggestedActionsProps> = ({ onSelect }) => {
	return (
		<SuggestedActions
			size="large"
			actions={[
				{
					label: FORM_AUTHORING_COACH_START_QUERY,
					icon: faSparkles,
					onClick: () => onSelect(FORM_AUTHORING_COACH_START_QUERY),
				},
			]}
		/>
	);
};

export default FormAuthoringCoachSuggestedActions;
